import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Solutions.css';
import { Shield, Brain, Lock, ShieldCheck } from 'lucide-react';

const solutions = [
  {
    icon: Brain,
    title: 'Healthcare AI Solutions',
    desc: 'AI-driven medical imaging, predictive analytics, and secure data platforms for healthcare providers handling sensitive patient information.',
    link: '/healthcare-ai',
  },
  {
    icon: Lock,
    title: 'Salus Tactical IAM and IGA',
    desc: 'Zero Trust identity & access management for tactical edge deployments with military-grade encryption and secure authentication.',
    link: '/salus-iam',
  },
  {
    icon: Shield,
    title: 'Cybersecurity & AI Security',
    desc: 'Comprehensive penetration testing, AI-driven threat detection, and compliance audits for federal and healthcare systems.',
    link: '/cybersecurity',
  },
  {
    icon: ShieldCheck,
    title: 'SapienShield Firewall',
    desc: 'The advanced AI Firewall solution, designed for the private and public sector enterprises.',
    link: '/sapienshield',
  },
];

const Solutions = () => {
  return (
    <div className="solutions-container">
      <Navbar />

      <main className="solutions-content">
        <header>
          <h1 className="solutions-heading">Our Solutions</h1>
          <p className="solutions-description">
            Explore how Sapiencia.AI can help your organization leverage AI securely across
            healthcare and defense operations.
          </p>
        </header>

        <section className="solution-cards">
          {solutions.map((solution) => {
            const Icon = solution.icon;

            return (
              <article className="solution-card" key={solution.title}>
                <div className="solution-icon">
                  <Icon size={32} />
                </div>

                <h2>{solution.title}</h2>

                <p>{solution.desc}</p>

                <Link to={solution.link} className="learn-more-btn">
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14"></path>
                    <path d="M12 5l7 7-7 7"></path>
                  </svg>
                </Link>
              </article>
            );
          })}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Solutions;